import SecondaryPagesImage from '../../components/SecondaryPagesImage';
import SecondaryPagesBanner from '../../components/SecondaryPagesBanner';
import profile from '../../images/profile.jpeg';
import { t } from 'i18next';
import { Trans, withTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import curriculum from '../../images/curriculum.jpeg';
import schoolDay from '../../images/school-day.jpeg';
import slide1 from '../../images/slide1.jpeg';
import parents from '../../images/parents.jpeg';

function MessageFromHT() {
    let { pathname } = useLocation();

    pathname = pathname.replace('/school-info/', '')

    const MAIN_BLOCK_DATA = {
       'school-profile': {
          header: `School profile`,
          image: profile,
          text: `largest Ukrainian Saturday community`
       },
       'school-curriculum': {
        header: `School curriculum`,
        image: curriculum,
        text: 'we believe that all children'
       },
       'school-curriculum/examinations': {
        header: 'Examinations',
        image: curriculum,
        text: ''
       },
       'school-day-and-terms': {
        header: 'School day & terms',
        image: schoolDay,
        text: 'school terms and a typical day'
       },
       'school-policies': {
        header: 'School policies',
        image: slide1,
        text: 'school terms and a typical day',
        // This page draws its own header
        hideBanner: true
       },
       'parent-teacher-association': {
        header: 'parents committee',
        image: parents,
        text: 'you can find',
        // This page draws its own header, so skip the shared image and banner
        hideBanner: true
       }
    };

    const pageData = MAIN_BLOCK_DATA[pathname];

    return(
      <>
        {!pageData.hideBanner && (
          <>
            <SecondaryPagesImage image={pageData.image} />
            <SecondaryPagesBanner header={<Trans i18nKey={pageData.header} />}
            text={<Trans i18nKey={pageData.text}/>}/>
          </>
        )}
        <Outlet />
      </>
    );
}

export default withTranslation()(MessageFromHT);